<mat-toolbar class="topbar gap-5">
  <!-- --------------------------------------------------------------- -->
  <!-- Desktop Menu -->
  @if (showToggle) {
    <button
      mat-icon-button
      (click)="toggleCollapsed.emit()"
      class="d-flex justify-content-center align-items-center">
      <i
        class="iconify icon-20 d-flex"
        data-icon="solar:hamburger-menu-line-duotone"></i>
    </button>
  }

  <!-- --------------------------------------------------------------- -->
  <!-- Mobile Menu -->
  @if (!showToggle) {
    <button
      mat-icon-button
      (click)="toggleMobileNav.emit()"
      class="d-flex justify-content-center align-items-center">
      <i
        class="iconify icon-20 d-flex"
        data-icon="solar:hamburger-menu-line-duotone"></i>
    </button>
  }
  <!-- --------------------------------------------------------------- -->

  <!-- --------------------------------------------------------------- -->
  <!--  Search -->
  <!-- --------------------------------------------------------------- -->
  <!--<button mat-icon-button (click)="openDialog()" class="d-flex align-items-center justify-content-center">
    <i class="iconify icon-20 d-flex" data-icon="solar:magnifer-outline"></i>
  </button>-->

  <button
    mat-icon-button
    (click)="openSearchDialog()"
    class="d-flex align-items-center justify-content-center">
    <i class="iconify icon-20 d-flex" data-icon="solar:magnifer-outline"></i>
  </button>

  <!-- Notification dropdown (MatDash-style) -->
  <app-inapp-notification-bell
    itemType="notification"
    class="d-none d-lg-flex align-items-center"></app-inapp-notification-bell>
  <!-- Tasks to do dropdown -->
  <app-inapp-notification-bell
    itemType="task"
    class="d-none d-lg-flex align-items-center"></app-inapp-notification-bell>

  <!-- --------------------------------------------------------------- -->
  <!--  APPS MENU -->
  <!-- --------------------------------------------------------------- -->

  <!--
  <div class="d-none d-lg-flex">
    <button mat-icon-button [matMenuTriggerFor]="appsmenu" aria-label="links"
      class="d-flex align-items-center justify-content-center">
      <i class="iconify icon-20 d-flex" data-icon="solar:widget-3-line-duotone"></i>
    </button>
    <mat-menu #appsmenu="matMenu" class="apps-dd cardWithShadow">
      <div class="row">
        <div class="col-sm-8 p-r-0">
          <div class="p-32 p-b-0">
            <div class="row">
              @for(appdd of apps; track appdd.title) {
              <div class="col-sm-6 text-hover-primary">
                <a [routerLink]="[appdd.link]" class="d-flex align-items-center text-decoration-none m-b-24">
                  <span class="text-{{ appdd.color }} bg-light-{{
                      appdd.color
                    }} rounded icon-48 d-flex align-items-center justify-content-center">
                    <span class="iconify icon-20" [attr.data-icon]="appdd.icon"></span>
                  </span>

                  <div class="m-l-16">
                    <h5 class="f-s-14 f-w-600 m-0 hover-text">
                      {{ appdd.title }}
                    </h5>
                    <span class="f-s-12 text-muted">{{ appdd.subtitle }}</span>
                  </div>
                </a>
              </div>
              }
            </div>
          </div>
        </div>
        <div class="col-sm-4">
          <img src="/assets/images/backgrounds/mega-dd-bg.jpg" alt="mega-dd-bg" class="mega-dd-bg" />
        </div>
      </div>
    </mat-menu>
  </div>
  -->

  <span class="flex-1-auto"></span>

  <!-- Artur — product launcher (superadmin only) -->
  <button
    *ngIf="canAccessSuperAdminProductLaunchers()"
    mat-flat-button
    type="button"
    color="primary"
    class="artur-ai-btn"
    aria-label="Open Artur"
    (click)="openArturAi()">
    <mat-icon class="artur-ai-btn__icon">
      <i
        class="iconify icon-20"
        data-icon="solar:magic-stick-3-bold-duotone"></i>
    </mat-icon>
    <span>Artur</span>
  </button>

  <!-- APScan (KYC / superadmin) -->
  <ng-container *ngIf="canAccessKycHeaderTools()">
    <button
      mat-flat-button
      (click)="logout_to_apscan()"
      class="apscan-btn connected bg-success text-white"
      *ngIf="authService.is_aptokenaccess == true">
      <mat-icon *ngIf="authService.is_aptokenaccess">
        <i-tabler name="logout" class="icon-20 d-flex"></i-tabler>
      </mat-icon>
      <span>APScan</span>
    </button>

    <button
      mat-flat-button
      (click)="connect_to_apscan()"
      class="apscan-btn disconnected bg-error text-white"
      *ngIf="authService.is_aptokenaccess == false">
      <mat-icon *ngIf="!authService.is_aptokenaccess">
        <i-tabler name="login" class="icon-20 d-flex"></i-tabler>
      </mat-icon>
      <span>APScan</span>
    </button>
  </ng-container>

  <!-- Aether Document Collector — every user: the GED view is everyone's
       workspace; users without client-portal (KYC) rights land on it directly. -->
  <button
    mat-flat-button
    type="button"
    class="dataroom-admin-btn"
    aria-label="Open Aether Document Collector admin"
    (click)="openDataroomAdmin()">
    <mat-icon class="dataroom-admin-btn__icon">
      <i-tabler name="shield-lock" class="icon-20 d-flex"></i-tabler>
    </mat-icon>
    <span>Aether Document Collector</span>
  </button>

  @if (options.theme == 'light') {
    <button
      mat-icon-button
      aria-label="lightdark"
      class="d-flex justify-content-center"
      (click)="setlightDark('dark')">
      <i-tabler class="d-flex icon-20" [name]="'moon'"></i-tabler>
    </button>
  } @else {
    <button
      mat-icon-button
      aria-label="lightdark"
      class="d-flex justify-content-center"
      (click)="setlightDark('light')">
      <i-tabler class="d-flex icon-20" [name]="'sun'"></i-tabler>
    </button>
  }

  <!-- Mobile Menu -->
  <button
    mat-icon-button
    (click)="toggleMobileFilterNav.emit()"
    class="d-flex d-lg-none justify-content-center align-items-center">
    <i class="iconify icon-20 d-flex" data-icon="solar:menu-dots-outline"></i>
  </button>

  <!-- --------------------------------------------------------------- -->
  <!-- Collpase bar -->
  <!-- --------------------------------------------------------------- -->
  <button
    mat-icon-button
    (click)="toggleCollpase()"
    class="d-flex d-lg-none justify-content-center">
    <i class="iconify icon-20 d-flex" data-icon="solar:sort-outline"></i>
  </button>
  @if (isCollapse) {
    <div class="header-collpase p-y-10 p-x-15">
      <div class="d-flex justify-content-center gap-10">
        <button
          *ngIf="canAccessSuperAdminProductLaunchers()"
          mat-flat-button
          type="button"
          color="primary"
          class="artur-ai-btn"
          aria-label="Open Artur"
          (click)="openArturAi()">
          <mat-icon class="artur-ai-btn__icon">
            <i
              class="iconify icon-20"
              data-icon="solar:magic-stick-3-bold-duotone"></i>
          </mat-icon>
          <span>Artur</span>
        </button>
        <app-inapp-notification-bell
          itemType="notification"
          class="d-flex align-items-center"></app-inapp-notification-bell>
        <app-inapp-notification-bell
          itemType="task"
          class="d-flex align-items-center"></app-inapp-notification-bell>
        <!-- --------------------------------------------------------------- -->
        <!-- langugage Dropdown -->
        <!-- --------------------------------------------------------------- -->
        <!--
      <button [matMenuTriggerFor]="flags" mat-icon-button class="m-r-5">
        <img [src]="selectedLanguage.icon" class="rounded-circle object-cover icon-20" />
      </button>
      -->

        <!-- --------------------------------------------------------------- -->
        <!-- Profile Dropdown -->
        <!-- --------------------------------------------------------------- -->
        <button
          mat-icon-button
          extended
          [matMenuTriggerFor]="profilemenu"
          aria-label="Notifications"
          class="position-relative d-flex align-items-center justify-content-center profile-btn-dd">
          <img
            [src]="profilePic()"
            class="rounded-circle icon-30 object-cover profile-dd d-flex align-items-center justify-content-center"
            width="30"
            height="30" />
        </button>
      </div>
    </div>
  }

  <!-- --------------------------------------------------------------- -->
  <!-- langugage Dropdown -->
  <!-- --------------------------------------------------------------- -->
  <!--
  <button [matMenuTriggerFor]="flags" mat-icon-button class="d-none d-lg-flex">
    <img [src]="selectedLanguage.icon" class="rounded-circle object-cover icon-20" />
  </button>
  <mat-menu #flags="matMenu" class="cardWithShadow">
    @for(lang of languages; track lang.icon) {
    <button mat-menu-item (click)="changeLanguage(lang)">
      <div class="d-flex align-items-center">
        <img [src]="lang.icon" class="rounded-circle object-cover m-r-8 icon-20" />
        <span class="f-s-14">{{ lang.language }}</span>
      </div>
    </button>
    }
  </mat-menu>
  -->

  <!-- --------------------------------------------------------------- -->
  <!-- Microsoft reconnect — hidden unless an Outlook/SharePoint feature -->
  <!-- could not get a Graph token silently.                            -->
  <!-- --------------------------------------------------------------- -->
  <app-microsoft-reconnect class="d-flex align-items-center"></app-microsoft-reconnect>

  <!-- --------------------------------------------------------------- -->
  <!-- profile Dropdown -->
  <!-- --------------------------------------------------------------- -->
  <button
    mat-button
    [matMenuTriggerFor]="profilemenu"
    aria-label="Profile"
    class="profile-btn d-none d-lg-flex">
    <div class="d-flex align-items-center gap-4">
      <img
        [src]="profilePic()"
        class="rounded-circle object-cover icon-35 profile-dd"
        width="35" />

      <i data-icon="solar:alt-arrow-down-bold" class="iconify f-s-8"></i>
    </div>
  </button>
  <mat-menu #profilemenu="matMenu" class="topbar-dd cardWithShadow">
    <div class="p-x-32 p-y-16">
      <div class="d-flex align-items-center p-b-24 b-b-1 m-t-16">
        <img [src]="profilePic()" class="rounded-circle" width="56" />
        <div class="m-l-16">
          <h6 class="f-s-14 f-w-600 m-0 d-flex align-items-center">
            {{ currentUser()?.first_name }} {{ currentUser()?.last_name }}
          </h6>
          <span class="text-muted"> {{ currentUser()?.email }} <br /></span>
          <span class="text-muted"> {{ currentUser()?.title }} </span>
        </div>
      </div>
    </div>
    <div class="p-x-32 p-b-16">
      <a
        class="p-8 text-decoration-none d-block text-hover-primary"
        [routerLink]="['/account-setting']">
        <div class="d-flex align-items-center gap-2">
          <i-tabler name="settings" class="icon-18 d-flex"></i-tabler>
          <h5 class="f-s-14 f-w-600 m-0 lh-md hover-text">Account Settings</h5>
        </div>
      </a>

      <a
        class="p-8 text-decoration-none d-block text-hover-primary"
        [routerLink]="['/it-support']">
        <div class="d-flex align-items-center gap-2">
          <i
            class="iconify icon-18 d-flex"
            data-icon="solar:headphones-round-sound-outline"></i>
          <h5 class="f-s-14 f-w-600 m-0 lh-md hover-text">IT Support</h5>
        </div>
      </a>

      <a
        class="p-8 text-decoration-none d-block text-hover-primary"
        [routerLink]="['/faq']">
        <div class="d-flex align-items-center gap-2">
          <i
            class="iconify icon-18 d-flex"
            data-icon="solar:question-square-bold-duotone"></i>
          <h5 class="f-s-14 f-w-600 m-0 lh-md hover-text">FAQ</h5>
        </div>
      </a>

      <a
        class="p-8 text-decoration-none d-block text-hover-primary"
        href="javascript:void(0)"
        (click)="logout()">
        <div class="d-flex align-items-center gap-2">
          <i-tabler name="logout" class="icon-18 d-flex"></i-tabler>
          <h5 class="f-s-14 f-w-600 m-0 lh-md hover-text text-danger">
            Logout
          </h5>
        </div>
      </a>
    </div>
  </mat-menu>
</mat-toolbar>
